const callback = (entries) => {
    for (const entry of entries) {
        if (entry.isIntersecting) {
            entry.target.classList.add('open')
        }
    }
}

const options = {
    threshold: 1.0,
    rootMargin: '0px 0px -15% 0px',
}

const observer = new IntersectionObserver(callback, options)

for (const item of document.querySelectorAll('.vp-block-front-page-numbers .item')) {
    observer.observe(item)
}
